var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66666 14.6667V15.5834C3.66666 16.3128 3.95639 17.0122 4.47211 17.528C4.98784 18.0437 5.68731 18.3334 6.41666 18.3334H15.5833C16.3127 18.3334 17.0121 18.0437 17.5279 17.528C18.0436 17.0122 18.3333 16.3128 18.3333 15.5834V14.6667M14.6667 11.0001L11 14.6667M11 14.6667L7.33332 11.0001M11 14.6667V3.66675",
    stroke: "#444BAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.eb6bce27ab156436b8d7f773e0c4a2e2.svg";
export { ForwardRef as ReactComponent };